import React, { Component } from 'react';
import HiddenTracks from './HiddenTracks.js';
import {setResampleMaster} from 'actions/index.js';
import LockButton from 'components/LockButton.js';
import EffectParameterSlider from 'effects/EffectParameterSlider.js';
import {PLAY_BUTTON, RECORD_BUTTON, ROLL_BUTTON, QUANTIZE_BUTTON,
        BPM_SLIDER,
        SWING_SLIDER,
        BPM_LOCK} from 'constants/contextual-help.js';
import { connect } from "react-redux";
import {setCommandInput} from 'actions/index.js';
import {setViewMode} from 'actions/index.js';
import {setIsRecording} from 'actions/index.js';
import {setContextualHelp} from 'actions/index.js';
import {setIsRecordingExpanded} from 'actions/index.js';
import {setCommandPrefix} from 'actions/index.js';
import {setQuantized} from 'actions/index.js';
import {setTrackRolling} from 'actions/index.js';
import {SCRIPTING_VIEW} from 'constants/view-modes.js';
import {isNumber} from 'utils/IsNumber.js';

class SequenceButtonsContainer extends Component {

    // playthiss or stops the sequencer
    play() {
        this.props.sequencerEngine.schedulePlay();
    }

    record() {
        let isRecording = !this.props.isRecording;
        this.props.sequencerEngine.recording(isRecording);
    }

    resample() {
        this.props.sequencerEngine.masterResampler.prepare();
        this.props.setResampleMaster(true);
    }

    toggleQuantize() {
        this.props.setQuantized(!this.props.quantized);
    }

    onClickRollingMode() {
        this.props.sequencerEngine.resolution = this.props.displayResolution;
        this.props.sequencerEngine.trackRolling = !this.props.trackRolling;
    }

    get isLoading() {
        return Object.keys(this.props.loadingSequence).some(
            (s) => this.props.loadingSequence[s] === true);
    }

    updateBpm(bpm) {
        if (isNumber(bpm)) {
            bpm = parseFloat(bpm);
            this.props.sequencerEngine.updateBpm(bpm);
            this.setState(this.state);

            if (this.timestretchTimeout !== undefined) {
                clearTimeout(this.timestretchTimeout);
            }
            this.timestretchTimeout = setTimeout(() => {
                this.props.sequencerEngine.tracks.map(
                    (track) => track.soundIds.map(
                        (soundId) => {
                            let sampler = track.samplers[soundId];
                            if (sampler.tempoSynced) {
                                sampler.syncTempo(bpm);
                            }
                        }));
                this.timestretchTimeout = undefined;
            }, 150);
        }
    }

    // called when user updates swing
    updateSwing(swing) {
        if (isNumber(swing)) {
            this.props.sequencerEngine.updateSwing(swing);
            this.setState(this.state);
        }
    }

    toggleLock() {
        this.props.sequencerEngine.togglePatternLock();
    }


    render() {
        let playClassName = "play-button ";
        if (this.props.playScheduled) {
            playClassName += " flashit";
        }

	let className = "sequencer-buttons-container";
	if (this.isLoading) {
	    className += " loading";
	}
	
        return (
		<div className={className}>
		<div
            onMouseOver={() => this.props.setContextualHelp(PLAY_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClick={() => this.play()} className="action-buttons">
                <span className={playClassName}>{this.props.isPlaying? 'STOP' : 'PLAY'}</span>
              </div>
              <div
                onMouseOver={() => this.props.setContextualHelp(RECORD_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                className="action-buttons" onClick={() => this.record()}>
                <span className={this.props.isRecording ? 'recording record-button' : 'record-button'}>{this.props.isRecordingExpanded ? 'RECORDING +' : this.props.isRecording ? 'RECORDING' : 'RECORD'}</span>
              </div>
              <div
                onMouseOver={() => this.props.setContextualHelp(ROLL_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                className="action-buttons" onClick={() => this.onClickRollingMode()}>
                <span className={this.props.trackRolling ? "infinity-mode infinity-button" : "infinity-button"}>ROLL</span>
              </div>
              <div
                onMouseOver={() => this.props.setContextualHelp(QUANTIZE_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                className="action-buttons" onClick={() => this.toggleQuantize()}>
                <span className={this.props.quantized ? "infinity-mode infinity-button" : "infinity-button"}>
                  {this.props.quantized ? 'QUANTIZED' : 'UNQUANTIZED'}
                </span>
              </div>
              {this.props.sequencerEngine.bpmParameter ?
                  <div className='bpm-container'>
                        <EffectParameterSlider
                              name="BPM"
                              contextualHelp={BPM_SLIDER}
                              parameter={this.props.sequencerEngine.bpmParameter}
                              root={1}
                              step={1}
                              min={1}
                              isParameter={true}
                              max={250}
                              />
                  </div> : ''}
                  <LockButton
                    contextualHelp={BPM_LOCK}
                    patternLocked={this.props.patternLocked}
                    toggleLock={() => this.toggleLock()}/>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setViewMode: viewMode => dispatch(setViewMode(viewMode)),
        setQuantized: quantized => dispatch(setQuantized(quantized)),
        setContextualHelp: element => dispatch(setContextualHelp(element)),
        setIsRecording: recording => dispatch(setIsRecording(recording)),
        setTrackRolling: rolling => dispatch(setTrackRolling(rolling)),
        setCommandPrefix: prefix => dispatch(setCommandPrefix(prefix)),
        setIsRecordingExpanded: recording => dispatch(setIsRecordingExpanded(recording)),
        setCommandInput: input => dispatch(setCommandInput(input)),
        setResampleMaster: (flag) => dispatch(setResampleMaster(flag)),
    }
};

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    return {
        viewMode: state.sequencer.viewMode,
        quantized: state.sequencer.quantized,
        isRecording: state.sequencer.isRecording,
        isRecordingExpanded: state.sequencer.isRecordingExpanded,
        isPlaying: state.sequencer.isPlaying[id] || false,
        isCommandDown: state.keyboard.isCommandDown,
        sequenceName: state.sequencer.sequenceName,
        loadingSequence: state.sequencer.loadingSequence,
        trackRolling: state.sequencer.trackRolling,
        patternLocked: state.sequencer.patternLocks[props.sequencerEngine.currentPattern] || false,
        playScheduled: state.clock.playScheduled,
        commandPrefix: state.commands.commandPrefix,
        displayResolution: state.sequencer.displayResolution,
        isResampling: state.tracks.isResampling || state.sequencer.resampleMaster,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SequenceButtonsContainer);

